import * as React from 'react'
import {cn} from '@frontrow/console/src/lib/utils'
import {Text} from './text'

export {Text}

const BASE = 'font-normal text-heading'

type HeadingProps = {
  children?: React.ReactNode
  addClass?: string
  dataTest?: string
}

export function H1({
  children,
  addClass,
  dataTest = 'page-title'
}: HeadingProps): React.ReactElement {
  return (
    <h1 className={cn(`${BASE} text-[36px] my-4`, addClass)} data-test={dataTest}>
      {children}
    </h1>
  )
}

export function H2({children, addClass, dataTest}: HeadingProps): React.ReactElement {
  return (
    <h2 className={cn(`${BASE} text-[24px] my-4`, addClass)} data-test={dataTest}>
      {children}
    </h2>
  )
}

export function H3({children, addClass, dataTest}: HeadingProps): React.ReactElement {
  return (
    <h3 className={cn(`${BASE} text-[21px] my-3`, addClass)} data-test={dataTest}>
      {children}
    </h3>
  )
}

export function H4({children, addClass, dataTest}: HeadingProps): React.ReactElement {
  return (
    <h4 className={cn(`${BASE} text-[16px] my-3`, addClass)} data-test={dataTest}>
      {children}
    </h4>
  )
}
